import { render, staticRenderFns } from "./PersonManagement.vue?vue&type=template&id=008af623&"
import script from "./PersonManagement.vue?vue&type=script&lang=js&"
export * from "./PersonManagement.vue?vue&type=script&lang=js&"
import style0 from "./PersonManagement.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports